module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', [_c('h2', {
    staticClass: "fm_head",
    attrs: {
      "id": "_idParaDest-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062970596_Contents#r_idParaDest-2"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_vii",
      "title": "vii"
    }
  }, [_vm._v("Epigraph")])])]), _vm._v(" "), _c('p', {
    staticClass: "epig"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Like the touch of rain she was")]), _vm._v(" "), _c('p', {
    staticClass: "epig"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("On a man’s flesh and hair and eyes")]), _vm._v(" "), _c('p', {
    staticClass: "epig"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("When the joy of walking thus")]), _vm._v(" "), _c('p', {
    staticClass: "epig"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Has taken him by surprise.")]), _vm._v(" "), _c('p', {
    staticClass: "orn1"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("“Like the Touch of Rain,” Edward Thomas")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5597d556","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780062970596_Epigraph.vue
// module id = 66
// module chunks = 0